var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningHeadBookEducationSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23,
    y1: 24,
    x2: 23,
    y2: 29
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,21V10c0-1.7-1.3-3-3-3H1v11h6C8.7,18,10,19.3,10,21L10,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,21V10c0-1.7,1.3-3,3-3h6v11h-6C11.3,18,10,19.3,10,21L10,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,18.1c0.3,0.3,0.5,0.6,0.8,0.9v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,24h4c1.1,0,2-0.9,2-2v-4h3l-3-6c0-5-4-9-9-9c-3.4,0-6.4,1.9-7.9,4.7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningHeadBookEducationSvgrepoCom);
export default __webpack_public_path__ + "static/media/learning-head-book-education-svgrepo-com.5e5a815f0c3ae8346ac977ca6e514343.svg";
export { ForwardRef as ReactComponent };